var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, Stack, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { RatioBillingConstant } from "../services/entity";
export var RatioBillingPopupComponent = function (props) {
    var _rowData$RatioBilling, _ratioBillingData$Rat;
    var rowData = props.rowData, onClose = props.onClose, onSubmit = props.onSubmit;
    var _a = useState(rowData !== null && rowData !== void 0 ? rowData : {}), ratioBillingData = _a[0], setRatioBillingData = _a[1];
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var amountContribution = (rowData === null || rowData === void 0 ? void 0 : rowData.Contribution) === RatioBillingConstant.Amount;
    var percentContribution = (rowData === null || rowData === void 0 ? void 0 : rowData.Contribution) === RatioBillingConstant.Percent;
    var amtPerContribution = (rowData === null || rowData === void 0 ? void 0 : rowData.Contribution) === RatioBillingConstant.Both;
    var isDisable = (rowData === null || rowData === void 0 || (_rowData$RatioBilling = rowData.RatioBilling[0]) === null || _rowData$RatioBilling === void 0 ? void 0 : _rowData$RatioBilling.AllowType) === RatioBillingConstant.AllowType;
    useEffect(function () {
        setRatioBillingData(rowData);
    }, [rowData]);
    var formdata = __spreadArray(__spreadArray([{
            type: FormItemTypes.ContainerItem,
            name: 'ratioBillingSection',
            label: '',
            value: null,
            spacing: 1,
            columnSize: 12,
            alignItems: 'center',
            justifyContent: amtPerContribution ? '' : 'space-between',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'empty',
                    label: ':',
                    value: null,
                    columnSize: 4.2
                }, percentContribution || amtPerContribution ? {
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: '',
                    value: null,
                    labelTypographyProps: {
                        fontSize: '12px',
                        fontWeight: '400',
                        color: '#8593A3'
                    },
                    children: "Percent %",
                    columnSize: 3,
                    sx: {
                        display: "flex",
                        justifyContent: "center"
                    }
                } : null, amountContribution || amtPerContribution ? {
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: '',
                    value: null,
                    labelTypographyProps: {
                        fontSize: '12px',
                        fontWeight: '400',
                        color: '#8593A3'
                    },
                    children: "Amount (₹)",
                    columnSize: 4.7,
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        marginRight: "10px"
                    }
                } : null]
        }, {
            type: FormItemTypes.Typography,
            name: '',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(Divider, null),
            sx: {
                margin: "-7px"
            },
            columnSize: 12
        }], (ratioBillingData === null || ratioBillingData === void 0 || (_ratioBillingData$Rat = ratioBillingData.RatioBilling) === null || _ratioBillingData$Rat === void 0 ? void 0 : _ratioBillingData$Rat.map(function (item, index) { return ({
        type: FormItemTypes.ContainerItem,
        name: 'ratioBillingSection',
        label: '',
        value: null,
        spacing: 1,
        alignItems: 'center',
        justifyContent: amtPerContribution ? '' : 'space-between',
        elements: [{
                type: FormItemTypes.Typography,
                name: item === null || item === void 0 ? void 0 : item.DisplayName,
                label: '',
                value: null,
                labelTypographyProps: {
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#8593A3'
                },
                children: item === null || item === void 0 ? void 0 : item.DisplayName,
                columnSize: 4
            }, {
                type: FormItemTypes.Typography,
                name: index + '_name',
                label: '',
                value: null,
                labelTypographyProps: {
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#8593A3'
                },
                children: ':',
                columnSize: 0.2
            }, percentContribution || amtPerContribution ? {
                type: FormItemTypes.NumberInput,
                name: 'Percent_' + index,
                label: '',
                maxLength: 3,
                maxValue: 100,
                value: item === null || item === void 0 ? void 0 : item.PercentageValue,
                disabled: isDisable,
                setFormState: function (formValues, percentValue, field) {
                    var _a;
                    var _rowData$RatioBilling2;
                    var newArr = [];
                    if ((rowData === null || rowData === void 0 || (_rowData$RatioBilling2 = rowData.RatioBilling) === null || _rowData$RatioBilling2 === void 0 ? void 0 : _rowData$RatioBilling2.length) == 2) {
                        var _ratioBillingData$Rat2;
                        var remainingPercent_1 = Number(100 - percentValue);
                        var amountCalculation_1 = (Number(percentValue) / 100 * Number(rowData === null || rowData === void 0 ? void 0 : rowData.Amount)).toFixed(2);
                        var remainingAmountCalculation_1 = (Number(100 - percentValue) / 100 * Number(rowData === null || rowData === void 0 ? void 0 : rowData.Amount)).toFixed(2);
                        newArr = ratioBillingData === null || ratioBillingData === void 0 || (_ratioBillingData$Rat2 = ratioBillingData.RatioBilling) === null || _ratioBillingData$Rat2 === void 0 ? void 0 : _ratioBillingData$Rat2.map(function (elem, ind) { return elem ? _objectSpread(_objectSpread({}, elem), {}, {
                            PercentageValue: index == ind ? percentValue : remainingPercent_1,
                            AmountValue: index == ind ? amountCalculation_1 : remainingAmountCalculation_1
                        }) : null; });
                        return {
                            Percent_0: index == 0 ? Number(percentValue) : remainingPercent_1,
                            Percent_1: index == 1 ? Number(percentValue) : remainingPercent_1,
                            Amount_0: index == 0 ? amountCalculation_1 : remainingAmountCalculation_1,
                            Amount_1: index == 1 ? amountCalculation_1 : remainingAmountCalculation_1,
                            UpdatedRowData: newArr
                        };
                    }
                    else {
                        var _ratioBillingData$Rat3;
                        var ratioAmount_1 = Number(percentValue) / 100 * Number(rowData === null || rowData === void 0 ? void 0 : rowData.Amount);
                        newArr = ratioBillingData === null || ratioBillingData === void 0 || (_ratioBillingData$Rat3 = ratioBillingData.RatioBilling) === null || _ratioBillingData$Rat3 === void 0 ? void 0 : _ratioBillingData$Rat3.map(function (elem, ind) { return index == ind ? _objectSpread(_objectSpread({}, item), {}, {
                            PercentageValue: percentValue,
                            AmountValue: ratioAmount_1.toFixed(2)
                        }) : item; });
                        return _a = {},
                            _a['Percent_' + index] = Number(percentValue),
                            _a['Amount_' + index] = ratioAmount_1.toFixed(2),
                            _a.UpdatedRowData = newArr,
                            _a;
                    }
                },
                InputProps: {
                    sx: {
                        fontSize: "14px",
                        fontWeight: "400",
                        borderRadius: "8px",
                        border: '1px solid #DEE4EB'
                    },
                    slotProps: {
                        input: {
                            sx: {
                                textAlign: 'right'
                            }
                        }
                    }
                },
                placeholder: '',
                columnSize: 3
            } : null, amountContribution || amtPerContribution ? {
                type: FormItemTypes.NumberInput,
                name: 'Amount_' + index,
                label: '',
                value: null,
                disabled: true,
                sx: {
                    display: 'flex',
                    justifyContent: 'end',
                    alignContent: 'end',
                    alignItems: 'end',
                    alignSelf: 'end'
                },
                setFieldProps: function (formValues, currValue) {
                    var ratioAmount = Number(formValues['Percent_' + index]) / 100 * Number(rowData === null || rowData === void 0 ? void 0 : rowData.Amount);
                    return {
                        type: this.type,
                        value: ratioAmount.toFixed(2)
                    };
                },
                InputProps: {
                    sx: {
                        fontSize: "14px",
                        fontWeight: "400",
                        justifyContent: 'end',
                        borderRadius: "8px",
                        border: '1px solid #DEE4EB',
                        justifyItems: 'end'
                    },
                    slotProps: {
                        input: {
                            sx: {
                                textAlign: 'right'
                            }
                        }
                    }
                },
                placeholder: '',
                columnSize: 4.7
            } : null],
        columnSize: 12
    }); })), true), [{
            type: FormItemTypes.Button,
            name: 'cancel',
            label: '',
            value: null,
            children: 'Cancel',
            columnSize: 6,
            fullWidth: true,
            variant: 'outlined',
            sx: {
                borderColor: '#DEE4EB',
                color: "#6A7682"
            },
            onClick: function () {
                onClose();
            }
        }, {
            type: FormItemTypes.Button,
            name: 'save',
            label: '',
            value: null,
            children: 'Save',
            columnSize: 6,
            fullWidth: true,
            variant: 'contained',
            disabled: isDisable,
            sx: {
                bgColor: '#EB6A2C',
                color: "#FFFFFF"
            },
            onClick: function (e, value) {
                onSubmit && onSubmit(value === null || value === void 0 ? void 0 : value.UpdatedRowData);
                //onClose()
            }
        }], false);
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            width: '100%',
            p: 0,
            maxHeight: '650px'
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer
    // isHeader={false}
    , {
        formData: formdata
    }));
};
